import { ChangeDetectionStrategy, Component, computed } from '@angular/core';
import { ErrorData } from 'lib/helpers/api-error-helper.class.js';
import { CoreAppComponent } from 'src/app/core/core-app.component.js';
import { environment } from 'src/app/environments/environment.js';
import { AppLogService } from '../services/app-log.service.js';

@Component({
	templateUrl: './global-error.component.html',
	styleUrl: './global-error.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class GlobalErrorComponent extends CoreAppComponent {
	public readonly latestError = computed<ErrorData | undefined>(() => {
		return this.logService.latestError();
	});

	public readonly contactUsText = computed<string>(() => {
		return `If the issue persists, please contact us on ${environment.helpEmail}`;
	});

	constructor(private readonly logService: AppLogService) {
		super();
	}

	goToDashboard(): void {
		// Use full reload in case the error is caused by old version of app
		window.location.href = this.dashboardUrl();
	}

	clearCookies(): void {
		this.cookieService.deleteCookie('Token');
		this.cookieService.deleteCookie('Theme');

		this.goToDashboard();
	}
}
